import React from "react";

import {
  Box,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import ContactAutocomplete from "./ContactAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1.5),
    fontSize: "0.82rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  fields: {
    display: "grid",
    gap: theme.spacing(1.5),
  },
  compactRow: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 2fr) minmax(86px, 1fr)",
    gap: theme.spacing(1),
  },
  errorSlot: {
    minHeight: 20,
    marginTop: theme.spacing(1),
  },
  error: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
  },
}));

const DealInlineEditor = ({
  form,
  formId,
  saving,
  error,
  pipelineName,
  stageName,
  users,
  contactOptions,
  contactsLoading,
  onContactSearch,
  onChange,
  onSubmit,
}) => {
  const classes = useStyles();
  const updateField = (field) => (event) => onChange(field, event.target.value);

  return (
    <Box
      id={formId}
      component="form"
      className={classes.root}
      onSubmit={onSubmit}
      noValidate
    >
      <Typography className={classes.title}>Editar negocio</Typography>
      <Box className={classes.fields}>
        <TextField
          fullWidth
          required
          autoFocus
          disabled={saving}
          variant="outlined"
          size="small"
          label="Titulo"
          value={form.title}
          error={Boolean(error) && !form.title.trim()}
          inputProps={{ "aria-label": "Titulo do negocio" }}
          onChange={updateField("title")}
        />

        <Box className={classes.compactRow}>
          <TextField
            fullWidth
            type="number"
            disabled={saving}
            inputProps={{
              min: 0,
              step: "0.01",
              "aria-label": "Valor do negocio",
            }}
            variant="outlined"
            size="small"
            label="Valor"
            value={form.amount}
            error={Number(form.amount) < 0}
            onChange={updateField("amount")}
          />
          <TextField
            fullWidth
            disabled={saving}
            variant="outlined"
            size="small"
            label="Moeda"
            value={form.currency}
            inputProps={{
              maxLength: 3,
              "aria-label": "Moeda do negocio",
            }}
            onChange={(event) =>
              onChange("currency", event.target.value.toUpperCase().slice(0, 3))
            }
          />
        </Box>

        <TextField
          fullWidth
          disabled
          variant="outlined"
          size="small"
          label="Pipeline"
          value={pipelineName || "-"}
          inputProps={{ "aria-label": "Pipeline do negocio" }}
        />
        <TextField
          fullWidth
          disabled
          variant="outlined"
          size="small"
          label="Etapa atual"
          value={stageName || "-"}
          inputProps={{ "aria-label": "Etapa atual do negocio" }}
        />
        <TextField
          fullWidth
          disabled={saving}
          variant="outlined"
          size="small"
          type="date"
          label="Previsao de fechamento"
          value={form.expectedCloseAt}
          onChange={updateField("expectedCloseAt")}
          InputLabelProps={{ shrink: true }}
          inputProps={{ "aria-label": "Previsao de fechamento" }}
        />
        <TextField
          fullWidth
          disabled={saving}
          variant="outlined"
          size="small"
          label="Origem"
          value={form.source}
          inputProps={{ "aria-label": "Origem do negocio" }}
          onChange={updateField("source")}
        />
        <ContactAutocomplete
          label="Contato"
          value={form.contact}
          options={contactOptions}
          loading={contactsLoading}
          disabled={saving}
          onInputChange={onContactSearch}
          onChange={(contact) => onChange("contact", contact)}
        />
        <TextField
          select
          fullWidth
          disabled={saving}
          variant="outlined"
          size="small"
          label="Responsavel"
          value={form.userId}
          SelectProps={{
            inputProps: { "aria-label": "Responsavel pelo negocio" },
          }}
          onChange={updateField("userId")}
        >
          <MenuItem value="">Sem responsavel</MenuItem>
          {users.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          multiline
          minRows={3}
          disabled={saving}
          variant="outlined"
          size="small"
          label="Descricao"
          value={form.description}
          inputProps={{ "aria-label": "Descricao do negocio" }}
          onChange={updateField("description")}
        />
      </Box>
      <Box className={classes.errorSlot} aria-live="polite">
        {error ? <Typography className={classes.error}>{error}</Typography> : null}
      </Box>
    </Box>
  );
};

export default DealInlineEditor;
